import { render } from "./ProductCart.vue?vue&type=template&id=12e027b6"
import script from "./ProductCart.vue?vue&type=script&lang=js"
export * from "./ProductCart.vue?vue&type=script&lang=js"

import "./ProductCart.vue?vue&type=style&index=0&id=12e027b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__